import React from 'react'
import '../style/Testimonials.scss'


export default function Testimonials() {
    const testimonialarr = [
        {
            text: `Միշտ կարծում էի, թե շյուղագործությունը միայն տատիկների համար է, բայց այս դասընթացը փոխեց պատկերացումներս։ Սովորեցի գործել թրենդային սվիտերներ ու գլխարկներ, որոնք հիմա մեծ հաճույքով կրում եմ։ Շատ հանգստացնող և ստեղծագործական պրոցես է, իսկ արդյունքը միշտ շոշափելի է ու ջերմ։`,
            name: 'Մարիա, 29 տարեկան'
        },
        {
            text: `Երկար ժամանակ ինքնուրույն էի փորձում սովորել, բայց ARDA-ում ամեն ինչ սիստեմավորվեց։ Հատկապես դուր եկավ React-ի փուլը, որտեղ իրական պրոյեկտների վրա աշխատեցինք։ Հիմա արդեն ունեմ պորտֆոլիո, որով հպարտանում եմ։`,
            name: `Անի, 21 տարեկան.`
        },
        {
            text: `Միշտ ցանկացել եմ հիմնավոր սովորել վերանորոգման գործը, բայց չգիտեի որտեղից սկսել։ Այս դասընթացն ինձ տվեց այն ամենը, ինչ պետք էր՝ նյութագիտությունից մինչև գործնական աշխատանք։ Հատկապես կարևոր էր սովորել, թե ինչպես ճիշտ հաշվարկել նախահաշիվը, որպեսզի ավելորդ ծախսեր չլինեն`,
            name: `Արմեն 28 տարեկան`
        },
        {
            text: `Շինարարության մեջ ամենակարևորը անվտանգությունն ու ճշգրտությունն է։ Էլեկտրամոնտաժի դասընթացի ժամանակ մենք մանրամասն անցանք բոլոր ստանդարտները։ Հիմա ես ինձ շատ ավելի վստահ եմ զգում օբյեկտի վրա աշխատելիս, քանի որ գիտեմ յուրաքանչյուր լարի ու միացման նշանակությունը։`,
            name: `Տիգրան 38 տարեկան`
        },
        {
            text:`Միշտ վախենում էի մկրատը ձեռքս վերցնել, բայց ARDA-ի դասընթացներն օգնեցին հաղթահարել այդ արգելքը: Մենթորները բացատրում են ամենաչնչին դետալները՝ սկսած մազի կառուցվածքից մինչև ամենաբարդ կտրվածքները: Հիմա ես ունեմ իմ առաջին հաճախորդները և անչափ շնորհակալ եմ այս հնարավորության համար`,
            name:'Լիանա, 20 տարեկան'
        }
    ]
    return (
        <section className="testimonials">
            <h2>Ի՞նչ են ասում մեր ուսանողները</h2>
            {testimonialarr.map((elem, index) => {
                return <div className="testimonial-item">
                    <p>{elem.text}</p>
                    <span className="author">{elem.name}</span>
                </div>
            })}

        </section>
    )
}
